export default "__VITE_ASSET__5M6mtPx$__"